import { runtimeLocale } from "./i18n/runtimeLocale";

export type AgeParts = { weeks: number; days: number; totalDays: number };

export function ageFromBirthday(birthday: string, asOf: Date = new Date()): AgeParts {
  const birth = new Date(birthday + "T00:00:00");
  const ms = asOf.getTime() - birth.getTime();
  const totalDays = Math.max(0, Math.floor(ms / 86_400_000));
  return {
    totalDays,
    weeks: Math.floor(totalDays / 7),
    days: totalDays % 7,
  };
}

export function formatAge(parts: AgeParts): string {
  const zh = runtimeLocale() === "zh";
  if (parts.totalDays < 7) return zh ? `${parts.totalDays}天` : `${parts.totalDays}d`;
  return zh ? `${parts.weeks}周${parts.days}天` : `${parts.weeks}w ${parts.days}d`;
}
